import React, { Component } from "react";
import { AiOutlineHome } from "react-icons/ai";

import stl from "./BoardHeader.module.scss";

class BoardHeader extends Component {
	render() {
		return (
			<>
                {/*<div id={stl.breadcrumbs}>*/}
                    {/*<div className={stl.wrapper}>*/}
                        {/*<div id={stl.nav}>*/}
                            {/*<img src='/sis/images/main/board/navHome.png' id={stl.navHome}/>*/}
                            {/*&nbsp;&nbsp;<img src='/sis/images/main/board/navNext.png' id={stl.navNext}/>&nbsp;&nbsp; <span id={stl.navText}>공지사항</span>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div id={stl.iconWrapper}>
                    <div className={stl.iconContainer}>
                        <span className={stl.title}>공지사항</span>
                    </div>
                </div>
			</>
		);
	}
}

export default BoardHeader;
